export interface ProfileFact {
  label: string;
  value: string;
}

export interface ProfileAward {
  year: string;
  title: string;
  detail: string;
}

export interface ProfilePhoto {
  src: string;
  caption: string;
}

export const profileIntro = {
  name: '小仓优子',
  nameEn: 'Ogura Yuko',
  tagline: '把每一个角色都当作真实存在的人去理解。',
  avatar: 'https://readdy.ai/api/search-image?query=professional%20editorial%20portrait%20of%20an%20elegant%20young%20East%20Asian%20actress%20in%20a%20refined%20deep%20wine%20red%20blouse%20against%20a%20clean%20warm%20cream%20studio%20background%2C%20soft%20directional%20lighting%2C%20calm%20confident%20expression%2C%20high%20fashion%20magazine%20aesthetic%2C%20high%20detail&width=800&height=1000&seq=ogura-profile-main&orientation=portrait',
  bio: '小仓优子，日本女演员。她以细腻自然的表演风格和富有层次的角色塑造而受到观众喜爱，作品横跨电影与电视剧，涵盖悬疑、家庭、爱情、文艺等多种题材。从初登荧幕的青涩新人，到如今能够驾驭复杂人物内心戏的实力派，她始终保持着对表演的敬畏与热爱。她相信，好的表演不是用力，而是让观众相信角色真的活着。',
};

export const profileFacts: ProfileFact[] = [
  { label: '出生日期', value: '1996 年 8 月 12 日' },
  { label: '出身地', value: '日本 神奈川县' },
  { label: '身高', value: '164 cm' },
  { label: '血型', value: 'A 型' },
  { label: '职业', value: '演员 / 模特' },
  { label: '出道年份', value: '2015 年' },
  { label: '经纪公司', value: '凛光演艺事务所' },
  { label: '特长', value: '钢琴、摄影、料理' },
  { label: '语言', value: '日语、英语' },
  { label: '兴趣爱好', value: '阅读、旅行、胶片摄影' },
];

export const profileExperience: ProfileFact[] = [
  { label: '2015', value: '通过选秀活动出道，出演个人首部电视剧。' },
  { label: '2017', value: '主演青春爱情电影《樱之约》，开始受到广泛关注。' },
  { label: '2019', value: '凭《东京暮色》获得年度新人女演员奖提名。' },
  { label: '2021', value: '出演律政悬疑剧《无声的证词》，成功实现角色转型。' },
  { label: '2023', value: '主演电影《逆光飞翔》，口碑与票房双收。' },
  { label: '2024', value: '主演奇幻爱情电影《星夜之约》，人气达到新高度。' },
];

export const profileAwards: ProfileAward[] = [
  { year: '2019', title: '最佳新人女演员 · 提名', detail: '年度电影评论奖 · 作品《东京暮色》' },
  { year: '2021', title: '最佳女主角 · 提名', detail: '东京电视剧大赏 · 作品《无声的证词》' },
  { year: '2023', title: '年度人气女演员 · 获奖', detail: '观众选择奖 · 作品《逆光飞翔》' },
  { year: '2024', title: '最佳银幕表现 · 提名', detail: '亚洲电影周 · 作品《星夜之约》' },
];

export const profilePhotos: ProfilePhoto[] = [
  {
    src: 'https://readdy.ai/api/search-image?query=elegant%20candid%20portrait%20of%20a%20young%20East%20Asian%20actress%20relaxing%20in%20a%20sunlit%20garden%20wearing%20a%20soft%20cream%20knitwear%2C%20warm%20natural%20light%2C%20gentle%20smile%2C%20lifestyle%20photography%2C%20high%20detail&width=900&height=1100&seq=ogura-gallery-01&orientation=portrait',
    caption: '阳光下的午后',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=elegant%20editorial%20portrait%20of%20a%20young%20East%20Asian%20actress%20in%20a%20deep%20wine%20red%20dress%20against%20a%20softly%20lit%20warm%20interior%2C%20moody%20cinematic%20lighting%2C%20graceful%20pose%2C%20high%20detail&width=900&height=1100&seq=ogura-gallery-02&orientation=portrait',
    caption: '红毯之外的优雅',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=elegant%20outdoor%20portrait%20of%20a%20young%20East%20Asian%20actress%20on%20a%20quiet%20street%20at%20golden%20hour%20wearing%20a%20light%20coat%2C%20warm%20amber%20light%2C%20thoughtful%20expression%2C%20documentary%20style%2C%20high%20detail&width=900&height=1100&seq=ogura-gallery-03&orientation=portrait',
    caption: '黄昏街角',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=elegant%20studio%20portrait%20of%20a%20young%20East%20Asian%20actress%20with%20soft%20window%20light%20and%20a%20plain%20cream%20backdrop%2C%20minimal%20clean%20aesthetic%2C%20calm%20natural%20expression%2C%20high%20detail&width=900&height=1100&seq=ogura-gallery-04&orientation=portrait',
    caption: '静谧时刻',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=elegant%20behind%20the%20scenes%20portrait%20of%20a%20young%20East%20Asian%20actress%20holding%20a%20script%20on%20a%20warm%20lit%20film%20set%2C%20golden%20ambient%20light%2C%20focused%20gentle%20expression%2C%20high%20detail&width=900&height=1100&seq=ogura-gallery-05&orientation=portrait',
    caption: '片场间隙',
  },
];